import { createStore } from 'effector';
import { type PayoutTicketFilters } from '~/entities/payout';
import { PayoutTicketPriority } from '~/entities/payout';
import { setTicketsFilter } from './events';

export const $ticketsFilter = createStore<PayoutTicketFilters>({
    priorities: [PayoutTicketPriority.PRIORITY_HIGH],
}).on(setTicketsFilter, (src, payload) => ({
    ...src,
    ...payload,
}));
